import { CSSProperties } from 'react';

export interface AnimateCounterProps {
  value: string;
  fontSize?: number;
  locale?: Intl.LocalesArgument;
  formatOptions?: Intl.NumberFormatOptions;
  addedCellStyle?: CSSProperties;
  prefix?: string;
  suffix?: string;
}

export interface AnimatedItem {
  value: string;
  x: number;
  y: number;
  opacity?: number;
  key: string;
}
export const separators = [',', '.'];
export const springConfig = { mass: 4, tension: 2000, friction: 100 };
export const DEFAULT_FONT_SIZE = 40;
